"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.installAppBaseThemeFollow = installAppBaseThemeFollow;
/**
 * Lets an App page show the theme its host names. Only the window that holds
 * the page speaks for it: the app around an embedded page, or the page itself
 * at the top (the StreamKit bar). The App runtime bundle ships it to both
 * Bridges, without the theme values of app-base-theme-tokens.ts.
 */
function installAppBaseThemeFollow(target) {
    const themes = ['light', 'dark', 'blue-white'];
    const follow = (event) => {
        const data = event.data;
        if (event.source !== target.parent)
            return;
        if (!data || data.type !== 'streamlain:app-theme/v1')
            return;
        if (typeof data.theme !== 'string' || !themes.includes(data.theme))
            return;
        target.document.documentElement.setAttribute('data-theme', data.theme);
    };
    target.addEventListener('message', follow);
    return () => target.removeEventListener('message', follow);
}
